import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nameTopicIsValid: true,
};
const formTopicValidationSlice = createSlice({
  name: "formTopicValidationSlice",
  initialState,
  reducers: {
    setNameTopicValidation: (state, action) => {
      state.nameTopicIsValid = action.payload;
    },
  },
});

export const { setNameTopicValidation } = formTopicValidationSlice.actions;

export default formTopicValidationSlice.reducer;
